import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import './styles/global.css';

import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import TemplatesPage from './pages/templates/TemplatesPage';
import TemplateEditorPage from './pages/templates/TemplateEditorPage';
import CertificatesPage from './pages/certificates/CertificatesPage';
import CreateCertificatePage from './pages/certificates/CreateCertificatePage';
import PublicFormPage from './pages/PublicFormPage';
import PaymentPage from './pages/PaymentPage';
import AdminPage from './pages/AdminPage';
import Layout from './components/layout/Layout';

function PrivateRoute({ children }) {
  const { institution, loading } = useAuth();
  if (loading) return <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh'}}>טוען...</div>;
  return institution ? children : <Navigate to="/login" />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* ציבורי */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/form/:slug" element={<PublicFormPage />} />
          <Route path="/payment/*" element={<PaymentPage />} />
          <Route path="/admin" element={<AdminPage />} />

          {/* פרטי */}
          <Route path="/" element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }>
            <Route index element={<Navigate to="/dashboard" />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="templates" element={<TemplatesPage />} />
            <Route path="templates/new" element={<TemplateEditorPage />} />
            <Route path="templates/:id" element={<TemplateEditorPage />} />
            <Route path="certificates" element={<CertificatesPage />} />
            <Route path="certificates/new" element={<CreateCertificatePage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
